import React from "react";
import styled from "styled-components";

export default styled.input`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    &:after {
        content: '';
        display: block;
        background: url(/images/unselected-checkbox.png);
        width: 31px;
        height: 31px;
        background-size: cover;
        position: absolute;
        top: -9px;
        left: -6px;
    }

    &:checked:after {
        background: url(/images/selected-checkbox.png);
    }
`;